import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

// Thin orange bar under the header that fills as the reader moves through the article.
export function ReadingProgress({
  targetRef
}: {
  targetRef: React.RefObject<HTMLElement>;
}) {
  const {
    scrollYProgress
  } = useScroll({
    target: targetRef,
    offset: ['start 120px', 'end end']
  });
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 260,
    damping: 40,
    restDelta: 0.001
  });
  return <div className="pointer-events-none fixed inset-x-0 top-[72px] z-40 h-[3px] bg-transparent" aria-hidden="true" data-id="element-94" data-mp="ctrimvyfv3wd">
      <motion.div className="h-full origin-left bg-brand" style={{
      scaleX
    }} data-id="element-95" data-mp="31v6igzipd95" />
    </div>;
}